'use strict';

define('global/head_nav/index', ['shared/runtime'], function (Runtime) {
  'use strict';

  var localMap = {
    'zh-cn': 'zh-cn',
    'en-us': 'en-us',
    'es-es': 'es-es',
    'pt-pt': 'pt-pt'
  };

  var HeaderFunction = {
    open: function open() {
      this.toggleNav.show(0);
      $('body').css({
        overflow: 'hidden'
      });
    },
    close: function close() {
      this.toggleNav.hide(0);
      $('body').css({
        overflow: 'auto'
      });
    },
    bindClickEvent: function bindClickEvent() {
      this.toggleBtn.on('click', function () {
        if (this.header.hasClass(this.activeClassName)) {
          this.header.removeClass(this.activeClassName);
          this.close();
        } else {
          this.header.addClass(this.activeClassName);
          this.open();
        }
      }.bind(this));

      this.toggleLangBtn.eq(0).on('click', function () {
        Runtime.changeLocale(localMap['pt-pt']);
      });
      this.toggleLangBtn.eq(1).on('click', function () {
        Runtime.changeLocale(localMap['es-es']);
      });
      this.toggleLangBtn.eq(2).on('click', function () {
        Runtime.changeLocale(localMap['en-us']);
      });
      this.toggleLangBtn.eq(3).on('click', function () {
        Runtime.changeLocale(localMap['zh-cn']);
      });
    },
    scrollHeaderShow: function scrollHeaderShow() {
      this.scrollHeader.slideDown(100);
    },
    scrollHeaderHide: function scrollHeaderHide() {
      this.scrollHeader.slideUp(100);
    },
    scrollHeaderShouldShow: function scrollHeaderShouldShow() {
      return $(document).scrollTop() > this.scrollAmount && !this.header.hasClass(this.activeClassName);
    },
    bindScrollEvent: function bindScrollEvent() {
      $(document).scroll(_.debounce(function () {
        this.scrollAmount = this.hero.height() ? this.hero.height() : 300;
        if (this.scrollHeaderShouldShow()) {
          this.scrollHeaderShow();
        } else {
          this.scrollHeaderHide();
        }
        // 如果当前scrollLeft()大于零，需要手动设置scrollHeader的left值
        this.scrollHeader.css({
          left: -$(document).scrollLeft()
        });
      }.bind(this), 50));
    },
    bindDisabledA: function bindDisabledA() {
      this.disabledA.on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    },
    init: function init() {
      // 用以计算滚动多少出现滚动后的header
      this.hero = $(document).find('.js-scroll-amount-taking-target');
      // Toggle相关
      this.activeClassName = 'active';
      this.header = $('#global_head_nav');
      this.toggleBtn = this.header.find('.js-toggle-btn');
      this.toggleLangBtn = this.header.find('.lang-switcher');
      this.toggleNav = this.header.find('.js-toggle-nav');
      // scroll相关
      this.scrollHeader = $('#global_head_nav_scroll');
      this.scrollAmount = this.hero.height() ? this.hero.height() : 300;
      // 无跳转功能的a连接
      this.disabledA = $('.js-header').find('.js-disable-a');
      // body
      this.bindDisabledA();
      this.bindClickEvent();
      this.bindScrollEvent();
      if (this.scrollHeaderShouldShow()) {
        this.scrollHeaderShow();
      } else {
        this.scrollHeaderHide();
      }
    }
  };
  return {
    init: HeaderFunction.init.bind(HeaderFunction)
  };
});